<template>
  <div class="dlnkprofils_component w-100">

    <div class="position-relative bg-primary overflow-hidden">
      <div class="container position-relative z-index-2 space-top-1 space-top-md-1 space-bottom-1 space-bottom-md-1">
        <div class="w-md-80 w-xl-60 text-center mx-md-auto">
          <div class="mb-7">
            <h1 class="display-4 text-white mb-4">Profils</h1>
          </div>
        </div>
      </div>
      <figure class="position-absolute right-0 bottom-0 left-0 mb-n1"><svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1"><path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"></path></svg></figure>
    </div>

  </div>
</template>

<script>

export default {
  props: [],
  data: function () {
    return {
      message: '',
      messsage_type: '',
    }
  },
  mounted() {
  },

  computed: {
  },

  methods: {

  },

}
</script>
